import React, { useState } from "react";
import Carousel, { slidesToShowDefaults } from "react-touch-carousel";

const MyComponent = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleChange = index => setActiveIndex(index);

  const carouselData = [
    {
      id: 1,
      image: "https://plus.unsplash.com/premium_photo-1671117131353-1fa6256d57e6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwzN3x8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60",
      title: "Image 1"
    },
    {
      id: 2,
      image: "https://images.unsplash.com/photo-1675208986290-a72414630bbe?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwzMnx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60",
      title: "Image 2"
    },
    {
      id: 3,
      image: "https://plus.unsplash.com/premium_photo-1663932464682-a8ffd67c7b85?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyNXx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60",
      title: "Image 3"
    },
  ];

  return (
    <Carousel
      index={activeIndex}
      onRequestChange={handleChange}
      align="center"
      infinite
      swipe
      drag
      renderItem={({ data, index, active }) => (
        <img
          src={data.image}
          alt={data.title}
          style={{
            width: "100%",
            height: 200,
            objectFit: "cover",
            opacity: active ? 1 : 0.7
          }}
        />
      )}
      data={carouselData}
    />
  );
};

export default MyComponent;

